export default __webpack_public_path__ + "static/media/boreal_wolfs_milk_tooth.3e431411.png";